module.exports = __webpack_public_path__ + "static/feature-3-d2a88f5be4793e2fbc193d120ffdaa8b.jpg";